import React, { useEffect, useState } from 'react';

// SERVICES
import { itemIDList } from './lists';
import { getSuggestions, handleAction } from './cardServices';

// LIBS
import { Link } from 'react-router-dom';
import Downshift from 'downshift';

// STYLES
import {
  TextField,
  Typography,
  Button,
  FormControl,
  FormControlLabel,
  Checkbox,
  Radio,
  RadioGroup,
  Chip,
  Paper,
  Switch,
  InputLabel,
  Select,
  MenuItem,
  CircularProgress,
  Box,
  Stack,
  FormLabel,
} from '@mui/material';

// ASSETS
import { ArrowBack, Save } from '@mui/icons-material';

// COMPONENTS
import { GoBackHeader } from '../../CreateClub/RelationshipClub/GoBackHeader';
import { HeaderTitle } from '../../CreateClub/RelationshipClub/HeaderTitle';
import ImportImage from 'js/components/TriiboComponents/ImportImage';
import Query from './Query';

export default function View({
  isCreatingCard,
  groups,
  setGroups,
  form,
  setForm,
  infosForEdit,
  handleSubmitCard,
  handleChange,
  handleChangeSwitch,
  classes,
  handleCheckArray,
  keywords,
  handleChangeKeywordDownshift,
  selectedKeywords,
  handleDeleteDownshift,
  organizations,
  handleChangeOrganizationDownshift,
  selectedOrgs,
  suggestions,
  orgsSuggestions,
  renderInput,
  renderSuggestion,
  cardDefaultWeb,
  setCardDefaultWeb,
  cardDefaultMobile,
  setCardDefaultMobile,
  cardDefaultDetails,
  setCardDefaultDetails,
  loading,
  cardTypes,
  selectedCardType,
  setSelectedCardType,
  returnType,
  setReturnType,
  selectedEstablishment,
  setSelectedEstablishment,
  selectedStore,
  setSelectedStore,
  selectedProduct,
  setSelectedProduct,
  selectedIdEdit,
  setSelectedIdEdit,
  invalidFields,
  setInvalidFields,
}) {
  const [loadingList, setLoadingList] = useState(false);

  // Atualiza o valor conforme as regras
  useEffect(() => {
    // Se a ordenação for por distância, força 'physical'
    if (form.orderType === 'location') {
      setReturnType(['physical']);
      updateCardReturnField(['physical']);
    }
  }, [form.orderType]);

  useEffect(() => {
    if (form?.action) {
      updateCardReturnField(returnType);
    }
  }, [form.action]);

  const updateCardReturnField = (value) => {
    const updatedForm = { ...form };

    if (!updatedForm.storePlacesQuery) {
      updatedForm.storePlacesQuery = {};
    }

    switch (selectedCardType.action) {
      case 'establishment_list':
        updatedForm.storePlacesQuery.establishmentType = Array.isArray(value) ? value : [value];
        break;
      case 'promotion_list':
        updatedForm.storePlacesQuery.promotionType = Array.isArray(value) ? value : [value];
        break;
      case 'product_list':
        updatedForm.storePlacesQuery.productType = Array.isArray(value) ? value : [value];
        break;
      default:
        break;
    }

    setForm(updatedForm);
  };

  const handleReturnTypeChange = (type) => {
    let newReturnType;

    if (returnType.includes(type)) {
      // Se já está selecionado, remove
      newReturnType = returnType.filter((t) => t !== type);
    } else {
      // Se não está selecionado, adiciona
      newReturnType = [...returnType, type];
    }

    // Garante que pelo menos um tipo está selecionado
    if (newReturnType.length === 0) {
      newReturnType = [type === 'physical' ? 'digital' : 'physical'];
    }

    setReturnType(newReturnType);
    updateCardReturnField(newReturnType);
  };

  return (
    <Box sx={{ padding: { xs: '2rem 1rem', md: '4rem 2rem' }, width: '100%' }}>
      <GoBackHeader />
      <HeaderTitle pageInfo={isCreatingCard ? 'Cadastrar card' : 'Editar card'} />

      <Box
        component="form"
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmitCard();
        }}
        sx={{ mt: 3 }}
      >
        <FormControl fullWidth>
          {/* Seção Tipo */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" fontWeight="bold" gutterBottom>
              Tipo
            </Typography>
            <RadioGroup
              row
              aria-label="type"
              name="Tipo"
              value={form.cardType}
              onChange={handleChange('cardType')}
            >
              <FormControlLabel
                value="card_list"
                control={<Radio color="primary" />}
                label="Lista"
              />
              <FormControlLabel
                value="card_item"
                control={<Radio color="primary" />}
                label="Item"
              />
              <FormControlLabel value="card_url" control={<Radio color="primary" />} label="URL" />
            </RadioGroup>
          </Box>

          {/* Seção Detalhes */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" fontWeight="bold" mb={3}>
              Detalhes
            </Typography>
            <Stack spacing={2}>
              <TextField
                fullWidth
                onChange={handleChange('title')}
                value={form.title}
                type="text"
                id="title"
                required
                label="Título"
              />
              <TextField
                fullWidth
                onChange={handleChange('subtitle')}
                value={form.subtitle}
                type="text"
                id="subtitle"
                required
                multiline
                label="Subtítulo"
              />
              <TextField
                fullWidth
                onChange={handleChange('description')}
                value={form.description}
                type="text"
                id="description"
                required
                multiline
                label="Descrição"
              />
            </Stack>
          </Box>

          {form.query !== '' ||
            (form.cardType !== 'card_list' && (
              <Typography variant="body1" fontWeight="bold" mb={2}>
                Filtros
              </Typography>
            ))}

          {form.cardType === 'card_item' && form.action !== 'app_screen' && (
            <TextField
              fullWidth
              onChange={handleChange('itemId')}
              value={form.itemId}
              type="text"
              id="itemId"
              label="ID do item"
              required
              sx={{ mb: 2 }}
            />
          )}

          {/* só aparece quando tem appFilter.query */}
          {form.cardType === 'card_list' && form.query !== '' && (
            <TextField
              fullWidth
              onChange={handleChange('query')}
              value={form.query}
              type="text"
              id="query"
              label="Query"
              required
              sx={{ mb: 2 }}
            />
          )}

          {form.cardType === 'card_url' && (
            <TextField
              fullWidth
              onChange={handleChange('url')}
              value={form.url}
              type="text"
              id="url"
              helperText="Em caso de link externo, inserir https:// no início da sua URL."
              label="URL"
              required
              sx={{ mb: 2 }}
            />
          )}

          {form.action === 'app_screen' && (
            <TextField
              fullWidth
              onChange={handleChange('itemId')}
              value={form.itemId}
              type="text"
              id="itemId"
              label="ID do item"
              required
              select
              sx={{ mb: 2 }}
            >
              {itemIDList.map(({ label, value }, index) => (
                <MenuItem key={itemIDList[index].value} value={itemIDList[index].value}>
                  {itemIDList[index].label}
                </MenuItem>
              ))}
            </TextField>
          )}

          {form.cardType === 'card_list' && (
            <>
              <FormControl fullWidth required sx={{ mb: 2 }}>
                <InputLabel id="card-type-label">Tipo de card</InputLabel>
                <Select
                  labelId="card-type-label"
                  id="card-type"
                  value={selectedCardType?.action || ''}
                  label="Tipo de card"
                  onChange={(e) => {
                    const selected = cardTypes.find((card) => card.action === e.target.value);
                    setSelectedCardType(selected);
                    handleAction(e, form, setForm, cardTypes, returnType, setSelectedCardType);
                  }}
                >
                  {cardTypes.map((card) => (
                    <MenuItem key={card.action} value={card.action}>
                      {card.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {form.action === 'establishment_list' ? (
                <FormControlLabel
                  control={
                    <Switch
                      checked={form?.storePlacesQuery?.hasPromo || false}
                      onChange={handleChangeSwitch('hasPromo')}
                      color="primary"
                    />
                  }
                  label="Apenas com promoções"
                  sx={{ mb: 2 }}
                />
              ) : form.action === 'promotion_list' ? (
                <FormControlLabel
                  control={
                    <Switch
                      checked={form?.storePlacesQuery?.hasVoucher || false}
                      onChange={handleChangeSwitch('hasVoucher')}
                      color="primary"
                    />
                  }
                  label="Apenas com cupom"
                  sx={{ mb: 2 }}
                />
              ) : null}

              <TextField
                fullWidth
                onChange={handleChange('geoRadius')}
                value={form.geoRadius}
                type="number"
                id="geoRadius"
                required
                label="Raio da busca (em km)"
                sx={{ mb: 2 }}
              />

              <FormControl fullWidth required sx={{ mb: 2 }}>
                <InputLabel id="order-type-label">Ordenação</InputLabel>
                <Select
                  labelId="order-type-label"
                  id="order-type"
                  value={form.orderType}
                  label="Ordenação"
                  onChange={handleChange('orderType')}
                >
                  <MenuItem value="location">Distância</MenuItem>
                  <MenuItem value="relevance">Prioridade</MenuItem>
                  <MenuItem value="alphabetical">Alfabética A-Z</MenuItem>
                </Select>
              </FormControl>

              {selectedCardType.label && (
                <>
                  <FormControl component="fieldset" sx={{ mb: 2 }}>
                    <FormLabel component="legend">Tipo de retorno:</FormLabel>
                    <Box display="flex" alignItems="center" gap={2}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={returnType.includes('physical')}
                            onChange={() => handleReturnTypeChange('physical')}
                            name="physical"
                          />
                        }
                        label={`${selectedCardType.label} Físicos`}
                      />
                      {form.orderType !== 'location' && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={returnType.includes('digital')}
                              onChange={() => handleReturnTypeChange('digital')}
                              name="digital"
                            />
                          }
                          label={`${selectedCardType.label} Digitais`}
                        />
                      )}
                    </Box>
                  </FormControl>

                  <Box>
                    <Query
                      groups={groups}
                      setGroups={setGroups}
                      form={form}
                      selectedCardType={selectedCardType}
                      infosForEdit={infosForEdit}
                      loadingList={loadingList}
                      setLoadingList={setLoadingList}
                      selectedEstablishment={selectedEstablishment}
                      setSelectedEstablishment={setSelectedEstablishment}
                      selectedStore={selectedStore}
                      setSelectedStore={setSelectedStore}
                      selectedProduct={selectedProduct}
                      setSelectedProduct={setSelectedProduct}
                      selectedIdEdit={selectedIdEdit}
                      setSelectedIdEdit={setSelectedIdEdit}
                      invalidFields={invalidFields}
                      setInvalidFields={setInvalidFields}
                    />
                  </Box>
                </>
              )}
            </>
          )}

          {/* Prioridade */}
          <TextField
            fullWidth
            onChange={handleChange('priority')}
            value={form.priority}
            type="number"
            id="priority"
            required
            label="Prioridade (0 a 9)"
            sx={{ mb: 3 }}
          />

          {/* Plataformas */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" fontWeight="bold" mb={1}>
              Plataformas
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={2}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.platform.includes('Web')}
                    onChange={handleCheckArray('platform')}
                    value="Web"
                    color="primary"
                  />
                }
                label="Web"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.platform.includes('iOS')}
                    onChange={handleCheckArray('platform')}
                    value="iOS"
                    color="primary"
                  />
                }
                label="iOS"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={form.platform.includes('Android')}
                    onChange={handleCheckArray('platform')}
                    value="Android"
                    color="primary"
                  />
                }
                label="Android"
              />
            </Box>
          </Box>

          <Downshift
            id="downshift-multiple"
            inputValue={keywords}
            onChange={handleChangeKeywordDownshift}
            selectedItem={selectedKeywords}
          >
            {({
              getInputProps,
              getItemProps,
              isOpen,
              inputValue,
              selectedItem,
              highlightedIndex,
            }) => (
              <div className={classes.container}>
                {renderInput({
                  fullWidth: true,
                  classes,
                  InputProps: getInputProps({
                    startAdornment: selectedKeywords.map((keyword) => (
                      <Chip
                        key={keyword}
                        tabIndex={-1}
                        label={keyword}
                        className={classes.chip}
                        onDelete={handleDeleteDownshift('keywords', keyword)}
                      />
                    )),
                    onChange: handleChange('keywords'),
                    placeholder: 'Selecione a keyword na lista abaixo',
                  }),
                  label: 'Keywords',
                })}
                {isOpen ? (
                  <Paper className={classes.paper} square>
                    {getSuggestions('keywords', inputValue, orgsSuggestions, suggestions).map(
                      (suggestion, index) =>
                        renderSuggestion({
                          suggestion,
                          index,
                          itemProps: getItemProps({ item: suggestion.label }),
                          highlightedIndex,
                          selectedItem,
                          type: 'keywords',
                        })
                    )}
                  </Paper>
                ) : null}
              </div>
            )}
          </Downshift>

          <Box sx={{ my: 3 }}>
            <Downshift
              id="downshift-multiple"
              inputValue={organizations}
              onChange={handleChangeOrganizationDownshift}
              selectedItem={selectedOrgs}
            >
              {({
                getInputProps,
                getItemProps,
                isOpen,
                inputValue,
                selectedItem,
                highlightedIndex,
              }) => (
                <div className={classes.container}>
                  {renderInput({
                    fullWidth: true,
                    classes,
                    InputProps: getInputProps({
                      startAdornment: selectedOrgs.map((item, index) => (
                        <Chip
                          key={item.orgID}
                          tabIndex={-1}
                          label={item.name}
                          className={classes.chip}
                          onDelete={handleDeleteDownshift('organizations', item)}
                        />
                      )),
                      onChange: handleChange('organizations'),
                      placeholder: 'Selecione a Organização na lista abaixo',
                    }),
                    label: 'Organizações',
                  })}
                  {isOpen ? (
                    <Paper className={classes.paper} square>
                      {getSuggestions('orgs', inputValue, orgsSuggestions, suggestions).map(
                        (suggestion, index) =>
                          renderSuggestion({
                            suggestion,
                            index,
                            itemProps: getItemProps({ item: suggestion }),
                            highlightedIndex,
                            selectedItem,
                          })
                      )}
                    </Paper>
                  ) : null}
                </div>
              )}
            </Downshift>
          </Box>

          {/* Imagens */}
          <Box sx={{ mb: 3 }}>
            <Typography variant="body1" fontWeight="bold" mb={1}>
              Imagens
            </Typography>
            <Stack spacing={2}>
              {/* Imagem Web */}
              <Box>
                <Typography variant="body2" gutterBottom>
                  Imagem web
                </Typography>
                <Box
                  sx={{
                    width: { xs: '100%', md: 600 },
                    height: 'auto',
                    maxWidth: '100%',
                  }}
                >
                  <ImportImage
                    imageDefault={true}
                    autoWidth={true}
                    image={cardDefaultWeb}
                    setImage={setCardDefaultWeb}
                    ratio={2.81 / 1}
                  />
                </Box>
              </Box>

              {/* Imagem Mobile */}
              <Box>
                <Typography variant="body2" gutterBottom>
                  Imagem mobile
                </Typography>
                <Box
                  sx={{
                    width: { xs: '100%', md: 600 },
                    height: 'auto',
                    maxWidth: '100%',
                  }}
                >
                  <ImportImage
                    imageDefault={true}
                    autoWidth={true}
                    image={cardDefaultMobile}
                    setImage={setCardDefaultMobile}
                    ratio={2.81 / 1}
                  />
                </Box>
              </Box>

              {/* Imagem Detalhes */}
              <Box>
                <Typography variant="body2" gutterBottom>
                  Imagem detalhes
                </Typography>
                <Box
                  sx={{
                    width: { xs: '100%', md: 400 },
                    height: { xs: 'auto', md: 300 },
                    maxWidth: '100%',
                  }}
                >
                  <ImportImage
                    imageDefault={true}
                    autoWidth={true}
                    image={cardDefaultDetails}
                    setImage={setCardDefaultDetails}
                    ratio={4 / 3}
                  />
                </Box>
              </Box>
            </Stack>
          </Box>

          {/* Datas */}
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mb: 3 }}>
            <TextField
              fullWidth
              id="datetime-local"
              label="Data de ativação"
              type="datetime-local"
              value={form.enableDate}
              onChange={handleChange('enableDate')}
              InputLabelProps={{ shrink: true }}
              required
            />
            <TextField
              fullWidth
              id="datetime-local"
              label="Data de desativação"
              type="datetime-local"
              value={form.disableDate}
              onChange={handleChange('disableDate')}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Stack>

          {/* Publicar card */}
          <FormControlLabel
            control={
              <Switch
                checked={form.isPublished}
                onChange={handleChangeSwitch('isPublished')}
                color="primary"
              />
            }
            label="Publicar card?"
            sx={{ mb: 3 }}
          />

          {/* Botões */}
          <Stack direction="row" spacing={2} sx={{ mt: 4 }}>
            <Button
              component={Link}
              to="/admin/configuracoes/cards"
              variant="contained"
              color="secondary"
              startIcon={<ArrowBack />}
              sx={{ textTransform: 'capitalize', color: 'white' }}
            >
              Voltar
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <Save />}
              disabled={loading}
              sx={{
                textTransform: 'capitalize',
                color: 'white',
                background: loading ? '#60B9C0' : undefined,
              }}
            >
              {loading ? 'Salvando...' : 'Salvar'}
            </Button>
          </Stack>
        </FormControl>
      </Box>
    </Box>
  );
}
